exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".accountingSummary{background-color:#fff;width:660px;height:100%;left:0px;top:0px;position:absolute;display:flex;flex-direction:column}", ""]);

